import React, {
  Fragment,
  useCallback,
  useEffect,
  useState,
  useRef,
} from 'react'
import config from 'config'

import { ENTER, TAB } from 'constants/keys'
import KeyboardNavigator from 'components/KeyboardNavigator'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'ducks/currentUser'
import {
  button,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'

import { styles } from './styles'
import AiOptions from './AiOptions'

const KEYBOARD_NAVIGATOR_KEYS = { select: [ENTER, TAB] }

const DropdownMenu = ({ onSelect, list }) => {
  const currentUser = useSelector(selectCurrentUser)
  const [isHotjarReady, setIsHotjarReady] = useState(!!window.hj)
  const hotjarConfig = config.hotjar

  const searchRef = useRef()
  const containerRef = useRef()
  const menuRef = useRef()

  const handleOpenSuggest = useCallback(
    () => {
      window.hj('identify', currentUser.id, {
        email: currentUser.email,
        name: `${currentUser.first_name} ${currentUser.last_name}`,
      })
      window.hj('event', 'ai_feedback')
      onSelect({})
    },
    [currentUser, onSelect]
  )

  useEffect(
    () => {
      const existing = document.getElementById('hotjar-script')
      if (existing) {
        return undefined
      }
      const handleLoad = () => {
        setIsHotjarReady(true)
      }
      const scriptTag = document.createElement('script')
      scriptTag.src = `https://static.hotjar.com/c/hotjar-${
        hotjarConfig.hjid
      }.js?sv=${hotjarConfig.hjsv}`
      scriptTag.id = 'hotjar-script'
      scriptTag.async = 'async'
      scriptTag.addEventListener('load', handleLoad)
      document.body.appendChild(scriptTag)

      return () => {
        scriptTag.removeEventListener('load', handleLoad)
      }
    },
    [hotjarConfig]
  )

  if (!currentUser.id) return null

  return (
    <div css={styles.container} ref={containerRef}>
      {list.map(
        section =>
          section && (
            <Fragment key={section.name}>
              <div css={styles.menuHeader}>{section.name}</div>
              <KeyboardNavigator
                keys={KEYBOARD_NAVIGATOR_KEYS}
                focusElement={searchRef.current}
                css={styles.wrapper}
                // We want to control it to allow more forgiving mouse leave
                activateOnHover={false}
              >
                <div className="grui" ref={menuRef}>
                  {section.items.map(item => (
                    <AiOptions key={item.id} item={item} onSelect={onSelect} />
                  ))}
                </div>
              </KeyboardNavigator>
            </Fragment>
          )
      )}
      <div css={styles.suggestContainer}>
        <button
          className="grui p-6 w-100 text-left"
          css={[
            button.styles.preflight,
            text.styles.fontSemibold,
            styles.button,
          ]}
          onClick={handleOpenSuggest}
          type="button"
          disabled={!isHotjarReady}
        >
          <span className="grui mr-2">⚡️</span>Suggest an AI feature or
          improvement
        </button>
      </div>
    </div>
  )
}

export default React.memo(DropdownMenu)
